export const LARGE_SELECTION_THRESHOLD = 100;
export const SEARCH_MIN_DISPLAYS = 2;
export const GROUPS_BATCH_SIZE = 15;
export const GROUPED_DISPLAYS_PAGE_SIZE = 15;
export const UNGROUPED_DISPLAYS_PAGE_SIZE = 25;

export const isLargeSelection = cart => cart.length > LARGE_SELECTION_THRESHOLD;

export const isSearchEnabled = cart => cart.length > SEARCH_MIN_DISPLAYS;

export const normalizeSearchText = text =>
  String(text || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim();

const getDisplaySearchText = display =>
  normalizeSearchText(
    `${display.name} ${display.resolution_width}x${display.resolution_height}`
  );

export const filterDisplaysBySearch = (displays, searchTerm) => {
  const term = normalizeSearchText(searchTerm);
  if (!term) return displays;
  return displays.filter(display => getDisplaySearchText(display).includes(term));
};

export const getCurrentPage = (page, total, pageSize) => {
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  return Math.min(Math.max(page || 1, 1), totalPages);
};

export const getPageItems = (items, page, pageSize) =>
  items.slice((page - 1) * pageSize, page * pageSize);
